import React, { useEffect, useState } from "react";
import styles from "./UserMangement.module.scss";
import CustomHeader from "components/common/CustomHeader/CustomHeader";
import Table from "components/common/Table/Table";
import SelectCustom from "components/common/Select/Select";

import {
  exportUsers,
  getAllUsers,
  handleUserStatus,
  profileIncompleteMail,
} from "reducer/admin/userMangenmentSlice";
import { useDispatch, useSelector } from "react-redux";
import { downloadFile, formatDateToReadable } from "utils/constants";
import DownloadIconSVG from "components/SVGComponents/DownloadIconSVG";
import { combineClasses, serverFiles } from "utils/utils";
import Tooltip from "components/common/Tooltip/Tooltip";
import ReportModal from "components/UI/ReportModal/ReportModal";
import ViewSVG from "components/SVGComponents/ViewSVG";
import { Controller, useForm } from "react-hook-form";
import {
  debounce,
  getStatusOption,
  selectStyles,
  statusOptions,
} from "../constants";
import FlagSVG from "components/SVGComponents/FlagSVG";
import ReportReason from "../SharedComponents/ReportReason/ReportReason";
import FilterModal from "./FilterModal";
import SendReminderIconSVG from "components/SVGComponents/SendReminder";
import toast from "components/Toast/toast";

const UserMangement = () => {
  const [pageSelected, setPageSelected] = useState(1);
  const [rowsPerPageValue, setRowsPerPageValue] = useState(10);
  const [reportModal, setReportModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [reportText, setReportText] = useState("");
  const [reasonModal, setReasonModal] = useState("");
  const [search, setSearch] = useState("");
  const { control } = useForm();
  const { filters } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const { users, totalCount, isUsersLoading, isExporting } = useSelector(
    (state) => state.users
  );

  const handleExport = async () => {
    const res = await dispatch(exportUsers()).unwrap();
    downloadFile(res);
  };
  const triggerPendingMail = async (id) => {
    try {
      const res = await dispatch(profileIncompleteMail(id)).unwrap();

      toast.success("Reminder email sent successfully!");
      dispatch(getAllUsers({ pageSelected, search: "" }));

    } catch (e) {
      toast.error("Failed to send reminder email");
    }
  };

  const handleToggleStatus = async (row) => {
    try {
      await dispatch(
        handleUserStatus({
          userId: row.id,
          isSuspended: !row.isSuspended,
          message: reportText,
        })
      ).unwrap();
      setReportModal(false);
      setReportText("");
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSearch = debounce((value) => {
    dispatch(getAllUsers({ pageSelected, search: value }));
    setSearch(value);
  }, 500);

  const handleReportModal = async (value, row) => {
    if (value === "inActive") {
      setReportModal(true);
    } else {
      handleToggleStatus(row);
    }
  };

  const columns = [
    {
      name: "User Name",
      selector: (row) => {
        const firstName = row?.firstName ?? "";
        const lastName =
          row?.userType === "CREATOR" ? row?.lastName ?? "" : "";

        const fullName = `${firstName} ${lastName}`.trim();

        return (
          <Tooltip
            data={fullName || "-"}
          />
        );
      },
    }
    ,
    {
      name: "User Type",
      selector: (row) => <Tooltip data={row?.userType} /> || "-",
      width: "8%",
    },
    {
      name: "Role",
      selector: (row) => {
        return row.industry ? <Tooltip data={row.industry} /> : "-";
      },
    },
    {
      name: "Niche",
      selector: (row) => {
        return row.category ? <Tooltip data={row.category.join(", ")} /> : "-";
      },
    },

    {
      name: "Email-Id",
      selector: (row) => {
        return row.industry ? <Tooltip data={row.email} /> : "-";
      },
    },
    {
      name: "Contact No",
      selector: (row) => row.mobileNo || "-",
    },
    {
      name: "Start Date",
      selector: (row) => formatDateToReadable(row.createdAt)[0] || "-",
    },
    {
      name: "Status",
      selector: (row) => (
        <Controller
          name={`status-${row.userAliasId}`}
          control={control}
          defaultValue={getStatusOption(!row.isSuspended)}
          render={({ field }) => (
            <SelectCustom
              {...field}
              onChange={(selectedOption) => {
                field.onChange(selectedOption);
                handleReportModal(selectedOption?.value, row);
                setSelectedRow(row);
              }}
              value={getStatusOption(!row.isSuspended)}
              options={statusOptions}
              styles={selectStyles(row.isSuspended)}
            />
          )}
        />
      ),
    },
    {
      name: "Edited By",
      selector: (row) => <Tooltip data={row.editedBy} /> || "-",
    },
    {
      name: "Edited At",
      selector: (row) => formatDateToReadable(row.modifiedAt)[0] || "-",
    },
    {
      name: "Pending Profile",
      selector: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {!row.isCompleted ? (
            <button
              onClick={() => triggerPendingMail(row.id)}
              style={{
                backgroundColor: "#3B82F6",
                color: "white",
                border: "none",
                cursor: "pointer",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: 500,
              }}
              title="Send Reminder Email"
            >
              Send Email
            </button>
          ) : (
            <span style={{ color: "#38A169", fontWeight: 500 }}>-</span>
          )}
        </div>
      ),
    }
    ,
    {
      name: "Action",
      selector: (row) => {
        return (
          <div className={styles.actions}>
            <a
              href={serverFiles(row?.portfolioUrl)}
              download
              target="_blank"
              rel="noopener noreferrer"
              className={combineClasses(
                styles.actionIcon,
                !row?.portfolioUrl && styles.disabled
              )}
            >
              <DownloadIconSVG color="#7E7E7E" />
            </a>
            <span>
              <FlagSVG
                height={20}
                width={18}
                fill={row?.isSuspended ? "#FF6A6A" : "none"}
                color={row?.isSuspended ? "#FF6A6A" : "#CCCCCC80"}
              />
            </span>
            {row?.isSuspended && (
              <span
                className={styles.view}
                onClick={() => setReasonModal(row.suspensionReason)}
              >
                <ViewSVG />
              </span>
              // <Tooltip
              //   data={row.suspensionReason}
              //   tooltipBackground="#FF3434"
              //   force={true}
              // >
              //   <ViewSVG />
              // </Tooltip>
            )}

            {/* {!row.isCompleted && (<span
              className={styles.view}
              onClick={() => triggerPendingMail(row.id)}
            >
              <SendReminderIconSVG size={18} color="#3B82F6" />
            </span>)} */}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getAllUsers({ pageSelected: pageSelected, search, filters: filters }));
  }, [pageSelected, dispatch]);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div className={styles.main}>
        <CustomHeader
          handleSearch={handleSearch}
          isExporting={isExporting}
          handleExport={handleExport}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
        {openModal && (
          <FilterModal onClose={() => setOpenModal(false)} search={search} />
        )}

        <Table
          columns={columns}
          data={users || []}
          className={styles.candidatesTable}
          progressPending={isUsersLoading}
          paginationProps={{
            isPagination: true,
            tableName: "User Managenment",
            pageSelected,
            totalCount: totalCount,
            rowsPerPageValue,
            setRowsPerPageValue,
            setPageSelected,
          }}
        />
        {reportModal && (
          <ReportModal
            reportModal={reportModal}
            setReportModal={setReportModal}
            coverImage={false}
            type="user"
            handleSubmit={() => handleToggleStatus(selectedRow)}
            setReport={setReportText}
          />
        )}
      </div>
      {reasonModal && (
        <ReportReason reason={reasonModal} setReasonModal={setReasonModal} />
      )}
    </>
  );
};

export default UserMangement;
